export default __webpack_public_path__ + "static/media/logo.b1e054e2.svg";